import ProofDeclarationList from "./proofDeclarationList";
export default ProofDeclarationList;